"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
const MySnackbarContentWrapper_1 = __importDefault(require("./MySnackbarContentWrapper"));
const CustomizedSnackbars = ({ variant, mensagem = '', duracao = 5000, horario = new Date(), }) => {
    const [open, setOpen] = react_1.useState(false);
    react_1.useEffect(() => {
        setOpen(true);
    }, [horario]);
    const onClose = () => {
        setOpen(false);
    };
    return (react_1.default.createElement(Snackbar_1.default, { anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, open: open, autoHideDuration: duracao, onClose: onClose, "cy-element": 'errorMessage' },
        react_1.default.createElement(MySnackbarContentWrapper_1.default, { onClose: onClose, variant: variant, message: mensagem })));
};
exports.default = CustomizedSnackbars;
//# sourceMappingURL=index.js.map